// extracted by mini-css-extract-plugin
export default {"page-not-found-container":"errorPage_page-not-found-container__nFPE+"};